import MessageBox from './ui/MessageBox';
const ErrorMessage = ({
  message
}) => <MessageBox message={message} type="error" data-sentry-element="MessageBox" data-sentry-component="ErrorMessage" data-sentry-source-file="ErrorMessage.jsx" />;
export default ErrorMessage;